import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import LoginForm from "../../features/user/LoginForm";
import ResetPasswordForm from "../../features/user/ResetPasswordForm";
import AcceptRejectInvoiceByEmail from "../../features/trackingDocument/invoice/invoiceByEmail/AcceptRejectInvoiceByEmail";

import ForLoggedUsers from "../layout/ForLoggedUsers";
import ForAdmins from "../layout/ForAdmins";

import DashboardHome from "../../features/home/DashboardHome";
import DashboardInvoice from "../../features/trackingDocument/invoice/DashboardInvoice";
import DashboardTrackingDocuments from "../../features/trackingDocument/DashboardTrackingDocuments";
import DashboardPayroll from "../../features/trackingPayroll/payroll/DashboardPayroll";
import DashboardTrackingPayrolls from "../../features/trackingPayroll/DashboardTrackingPayrolls";
import DashboardSupplier from "../../features/configuration/company/supplier/DashboardSupplier";
import DashboardUsers from "../../features/configuration/company/users/DashboardUsers";
import DashboardResolutions from "../../features/configuration/resolutions/resolutions/DashboardResolutions";
import DashboardCertificate from "../../features/configuration/resolutions/certificate/DashboardCertificate";
import DashboardDian from "../../features/configuration/dian/DashboardDian";
import DashboardDianV2 from "../../features/configuration/dian/DashboardDianV2";
import Configuration from "../../features/configuration/DashboardConfiguration";

import { sectionsConfiguration } from "../../app/util/breadcrumbOptions";




const RoutesComponent = () => {
  const match = {
    path: '/home'
  }

  return (
    <Routes>
      <Route
        path={`${match.path}/Dashboard`}
        element={
          <ForLoggedUsers>
            <DashboardHome />
          </ForLoggedUsers>
        }
      />
      <Route
        path={`${match.path}/TrackingDocuments/InvoiceDetail/:invoiceName/:id/:tab`}
        element={
          <ForLoggedUsers>
            <DashboardInvoice />
          </ForLoggedUsers>
        }
      />
      <Route
        path={`${match.path}/TrackingDocuments`}
        element={
          <ForLoggedUsers>
            <DashboardTrackingDocuments />
          </ForLoggedUsers>
        }
      />

      <Route
        path={`${match.path}/TrackingPayrolls/:id/:tab?`}
        element={
          <ForLoggedUsers>
            <DashboardPayroll />
          </ForLoggedUsers>
        }
      />
      <Route
        path={`${match.path}/TrackingPayrolls`}
        element={
          <ForLoggedUsers>
            <DashboardTrackingPayrolls />
          </ForLoggedUsers>
        }
      />

      <Route
        path={`${match.path}/Configuration/DashboardSupplier`}
        element={
          <ForAdmins>
            <DashboardSupplier sections={sectionsConfiguration} />
          </ForAdmins>
        }
      />
      <Route
        path={`${match.path}/Configuration/DashboardUsers`}
        element={
          <ForAdmins>
            <DashboardUsers sections={sectionsConfiguration} />
          </ForAdmins>
        }
      />
      <Route
        path={`${match.path}/Configuration/ElectronicResolutions`}
        element={
          <ForAdmins>
            <DashboardResolutions sections={sectionsConfiguration} />
          </ForAdmins>
        }
      />
      <Route
        path={`${match.path}/Configuration/DigitalCertificate`}
        element={
          <ForAdmins>
            <DashboardCertificate sections={sectionsConfiguration} />
          </ForAdmins>
        }
      />
      <Route
        path={`${match.path}/Configuration/SetDian`}
        element={
          <ForAdmins>
            <DashboardDian sections={sectionsConfiguration} />
          </ForAdmins>
        }
      />
      <Route
        path={`${match.path}/Configuration/SetDian-v2`}
        element={
          <ForAdmins>
            <DashboardDianV2 sections={sectionsConfiguration} />
          </ForAdmins>
        }
      />
      <Route
        path={`${match.path}/Configuration`}
        element={
          <ForAdmins>
            <Configuration />
          </ForAdmins>
        }
      />

<Route path="/invoice/:invoice" element={<AcceptRejectInvoiceByEmail />} />
      <Route path="/users/reset/:resetToken" element={<ResetPasswordForm />} />
      <Route path="/" element={<LoginForm />} />
      <Route path="*" element={<Navigate to="/home/Dashboard" replace />} />
    </Routes>
  );
};

export default RoutesComponent;
